import { getData } from "../api-client";
import {
  WEB_USER,
  GET_ALL_COURSES
} from "../../shared/constants/routing-constants";

export function getAllCourses(params: { search?: string; difficulty?: string; offset?: number; limit?: number }) {
  const queryParams = new URLSearchParams();
  if (params.search) queryParams.append('search', params.search);
  if (params.difficulty) queryParams.append('difficulty', params.difficulty);
  if (params.offset) queryParams.append('offset', params.offset.toString());
  if (params.limit) queryParams.append('limit', params.limit.toString());

  return getData(`${WEB_USER}/${GET_ALL_COURSES}?${queryParams.toString()}`);
}
